export class CDKCustomerInfo {
	dmsCustomerNumber: string = null;

	constructor(init?: CDKCustomerInfo) {
		this.dmsCustomerNumber = init?.dmsCustomerNumber;
	}
}
